var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import uniqueId from 'lodash/uniqueId';
import isUndefined from 'lodash/isUndefined';
import { getParagraphsWeight } from './util';
import { ACTION_TYPE, WEIGHT } from './const';

/**
 * парсер карточки типа @see CARD_TYPES.text @see CARD_TYPES.textWithButton
 * @param  {Object} card
 * @return {Card}
 */
export default (function (card) {
    if (isUndefined(card.text)) {
        return null;
    }

    var buttons = (card.buttons || []).map(buttonFactory).filter(Boolean);

    var text = String(card.text).split('\n\n').map(function (string) {
        return string.split('\n');
    });
    var textWeight = getParagraphsWeight(text);

    return _extends({}, card, {
        text: text,
        id: uniqueId('card_'),
        buttons: buttons,
        weight: WEIGHT.bubble + textWeight + buttons.length * WEIGHT.buttonLine
    });
});

/**
 * Фбрика кнопки для карточки
 * @param  {Object} button
 * @return {Object}
 */
var buttonFactory = function buttonFactory(button) {
    if (!button) {
        return null;
    }

    return {
        id: uniqueId('button_'),
        title: button.title,
        payload: payloadFactory(button.directives)
    };
};

/**
 * Фабрика данных для кнопки
 * @param {Array} directives
 * @return {Payload}
 */
var payloadFactory = function payloadFactory() {
    var directives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return {
        directives: directives.filter(Boolean),
        type: ACTION_TYPE.button
    };
};